import { jsx as _jsx } from "react/jsx-runtime";
import './Loader_OrderButton.scss';
export const Loader_OrderButton = () => {
    return _jsx("div", { className: 'loader__order-button' });
};
//# sourceMappingURL=Loader_OrderButton.js.map